import { Position } from "geojson";
import { PointTuple } from "leaflet";

//GeoCoordinates are in the format [longitude, latitude, altitude?] (https://tools.ietf.org/html/rfc7946#section-3.1.1)
//LatLng are in the format [latitude, longitude] (https://developers.google.com/maps/documentation/javascript/reference/coordinates#LatLng)
//This functions converts GeoCoordinates to LatLng

export const convertSingleCoordinate = (coordinate: Position): PointTuple => {
  return [coordinate[1], coordinate[0]];
};

export const convertCoordinatesArray = (coordinateArray: Position[]) => {
  return coordinateArray.map(convertSingleCoordinate);
};

export const convertCoordinates2DArray = (coordinate2DArray: Position[][]) => {
  return coordinate2DArray.map(convertCoordinatesArray);
};

export const convertCoordinates3DArray = (coordinate3DArray: Position[][][]) => {
  return coordinate3DArray.map(convertCoordinates2DArray);
};
